import { useQuery } from '@tanstack/react-query'

export const MARKET_DATA_BASE_URL = 'https://dextoro-market-data-production.up.railway.app'
const HEALTH_URL = `${MARKET_DATA_BASE_URL}/health`

export interface MarketDataHealth {
  status: string             // 'ok' on healthy
  timestamp: string          // ISO string
  subscriptions: number      // total active TradingView subscriptions
  globalSubscribers: number  // total WS subscribers
  fetchedAt: number          // appended client-side, mirrors useSeedbotHealth
}

/**
 * Polls dextoro-market-data /health every 30s. Throws on non-2xx so the
 * useQuery error state surfaces in BackendServicesSection.
 *
 * Source of truth for the response shape:
 * dextoro-market-data/src/index.ts:55-62
 */
export function useMarketDataHealth() {
  return useQuery({
    queryKey: ['market-data-health'],
    queryFn: async (): Promise<MarketDataHealth> => {
      const res = await fetch(HEALTH_URL)
      if (!res.ok) throw new Error(`Health endpoint returned ${res.status}`)
      const data = await res.json()
      return { ...data, fetchedAt: Date.now() }
    },
    staleTime: 15_000,
    refetchInterval: 30_000,
  })
}
